export const SlackPluginClientID = '158926675253.8397744408117';
export const GA_ID = 'G-CBV441CZQB';
export const RECAPTCHA_SITE_KEY = '6LfE_UQtAAAAAPr0fqJ77x8eQdV9LC-p8yjVBrUh';
export const RECAPTCHA_EARLY_ACCESS_ACTION = 'gn_early_access_prod';
export const STRIPE_PK = '';
